import { render, staticRenderFns } from "./s1-6.vue?vue&type=template&id=0cca89be&scoped=true&"
import script from "./s1-6.vue?vue&type=script&lang=js&"
export * from "./s1-6.vue?vue&type=script&lang=js&"
import style0 from "./s1-6.vue?vue&type=style&index=0&id=0cca89be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca89be",
  null
  
)

export default component.exports